export default "__VITE_ASSET__$2s$WpCx__"